import buildDisplayedAbilitySnapshot from './buildDisplayedAbilitySnapshot'
import loadCharacterValues from './loadCharacterValues'

export default function buildDisplayedCharacterSnapshot(character) {
  if (!character || typeof character !== 'object') {
    return character
  }

  const snapshot = window.$deepCopy
    ? window.$deepCopy(character)
    : JSON.parse(JSON.stringify(character))

  snapshot.characteristics = Array.isArray(snapshot.characteristics)
    ? snapshot.characteristics.map((entry) => ({
        ...entry,
        characteristic_adjs: Array.isArray(entry?.characteristic_adjs)
          ? entry.characteristic_adjs
          : [],
        integrated_rune_characteristic_adjs: Array.isArray(
          entry?.integrated_rune_characteristic_adjs,
        )
          ? entry.integrated_rune_characteristic_adjs
          : [],
      }))
    : []
  snapshot.skills = Array.isArray(snapshot.skills)
    ? snapshot.skills.map((skill) => ({
        ...skill,
        character_skill_adjs: Array.isArray(skill?.character_skill_adjs)
          ? skill.character_skill_adjs
          : [],
        characteristic_skill_adjs: Array.isArray(skill?.characteristic_skill_adjs)
          ? skill.characteristic_skill_adjs
          : [],
        integrated_rune_skill_adjs: Array.isArray(skill?.integrated_rune_skill_adjs)
          ? skill.integrated_rune_skill_adjs
          : [],
      }))
    : []
  snapshot.items = Array.isArray(snapshot.items) ? snapshot.items : []
  snapshot.runes = Array.isArray(snapshot.runes) ? snapshot.runes : []
  snapshot.ability_adjs = Array.isArray(snapshot.ability_adjs) ? snapshot.ability_adjs : []
  snapshot.characteristic_adjs = Array.isArray(snapshot.characteristic_adjs)
    ? snapshot.characteristic_adjs
    : []
  snapshot.characteristic_skill_adjs = Array.isArray(snapshot.characteristic_skill_adjs)
    ? snapshot.characteristic_skill_adjs
    : []
  snapshot.skill_adjs = Array.isArray(snapshot.skill_adjs) ? snapshot.skill_adjs : []
  snapshot.armour_locations = Array.isArray(snapshot.armour_locations)
    ? snapshot.armour_locations
    : []
  snapshot.campaign_notes = Array.isArray(snapshot.campaign_notes) ? snapshot.campaign_notes : []

  return buildDisplayedAbilitySnapshot(loadCharacterValues(snapshot))
}
